export default "__VITE_ASSET__BGxPoNCG__"